import React from "react";
import { NavLink, Outlet } from "react-router-dom";

export default function AdminNAVPage() {
  const linkStyle = ({ isActive }) => ({
    padding: "8px 12px",
    borderRadius: 10,
    textDecoration: "none",
    fontWeight: 800,
    color: isActive ? "#fff" : "#26428b",
    background: isActive ? "#26428b" : "rgba(38,66,139,0.10)",
  });

  return (
    <div style={{ padding: 14 }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 10,
          marginBottom: 12,
        }}
      >
        <div style={{ fontSize: 18, fontWeight: 900, color: "#26428b" }}>
          Admin Panel
        </div>

        <div style={{ display: "flex", gap: 8, marginLeft: 10 }}>
          <NavLink to="/admin/nav" style={linkStyle}>
            Navigation Links
          </NavLink>
          <NavLink to="/admin/access-master" style={linkStyle}>
             Access Master
           </NavLink>
          <NavLink to="/admin/whatsnew" style={linkStyle}>
            What’s New
          </NavLink>
          <NavLink to="/admin/posts" style={linkStyle}>
            Posts
          </NavLink>
          <NavLink to="/admin/mailer" style={linkStyle}>
  Mailer Control
</NavLink>


        </div>
      </div>

      <div
        style={{
          background: "#fff",
          border: "1px solid rgba(0,0,0,0.08)",
          borderRadius: 14,
          padding: 12,
          boxShadow: "0 1px 12px rgba(0,0,0,0.04)",
          minHeight: "70vh",
        }}
      >
        <Outlet />
      </div>
    </div>
  );
}